import { createApi } from '@core/fetch'

export default {
  // 触发天宫任务
  addCpmJob: createApi('/p/wedding/index.php/Admin/APICpmFlowPacket/addCpmJob')
}
